import { Button, Select } from "antd";
import React, { useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Creators as ManufacturerActions } from "../../../store/ducks/manufacturer";
import { ContainerSelectManufacturer, CustomSelect } from "./styles";

function SelectManufacturer({
  customSelect = false,
  placeholder = null,
  value,
  onDeselect,
  onChange,
  disabled = false,
  allowClear = true,
  showSearch = true,
}) {
  const {
    groupSelected: { id: groupId },
    farmSelected: { id: farmId },
    translation,
  } = useSelector((state) => state.app);

  const {
    listDropDown,
    isLoadingDropDown,
    newManufacturer,
    shouldRefreshListDropDown,
  } = useSelector((state) => state.manufacturer);

  const dispatch = useDispatch();
  const awaitingCreate = useRef(false);

  const getManufacturerList = useCallback(() => {
    dispatch(ManufacturerActions.getDropdownManufacturers(groupId, farmId));
  }, [dispatch, groupId, farmId]);

  const createNewManufacturer = useCallback(() => {
    awaitingCreate.current = true;
    dispatch(ManufacturerActions.showDrawer());
  }, [dispatch]);

  useEffect(() => {
    getManufacturerList();
  }, [getManufacturerList]);

  useEffect(() => {
    if (awaitingCreate.current && newManufacturer?.id) {
      onChange(newManufacturer.id);
      awaitingCreate.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldRefreshListDropDown]);

  const options = listDropDown.map((item) => (
    <Select.Option key={item.id} value={item.id}>
      {item.name}
    </Select.Option>
  ));

  const hasMatchingOption = listDropDown.some((item) => item.id === value);

  const selectProps = {
    loading: isLoadingDropDown,
    value: hasMatchingOption ? value : undefined,
    placeholder: placeholder
      ? placeholder
      : translation.defaultSelectPlaceholder,
    showSearch,
    optionFilterProp: "children",
    filterOption: (input, option) =>
      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
    allowClear,
    disabled,
    onDeselect,
    onChange,
  };

  const SelectElement = customSelect ? (
    <CustomSelect {...selectProps}>{options}</CustomSelect>
  ) : (
    <Select {...selectProps}>{options}</Select>
  );

  return (
    <ContainerSelectManufacturer>
      {SelectElement}
      <Button
        shape="circle"
        icon="plus"
        disabled={disabled}
        onClick={createNewManufacturer}
      />
    </ContainerSelectManufacturer>
  );
}

export default SelectManufacturer;
